import { FileUploadModule } from "@/store/modules/fileUpload.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const fileListingMachine = Machine({
    id: "fileMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "fileName",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
        uploadedFile: null,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_FILES: { target: "gettingFiles" },
            },
        },
        gettingFiles: {
            tags: "gettingFiles",
            invoke: {
                id: "gettingFiles",
                src: (context, event) => {
                    return FileUploadModule.GetFiles(context.searchData);
                },
                onDone: { target: "loadedFiles" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedFiles: {
            initial: "idle",
            states: {
                idle: {
                    on: {
                        GETTING_FILES: { target: "#fileMachine.gettingFiles", actions: "assignSearchData" },
                        GENERATE_SAS: { target: "uploadedFiles.gettingUploadSASUrl", actions: "assignFile" },
                        DELETE_FILE: { target: "#fileMachine.loadedFiles.deleteFile", actions: "ispageChanged" },
                    },
                },
                uploadedFiles: {
                    initial: "gettingUploadSASUrl",
                    states: {
                        gettingUploadSASUrl: {
                            tags: "showUploadUI",
                            invoke: {
                                id: "gettingUploadSASUrl",
                                src: (context, event) => {
                                    return FileUploadModule.GetUploadSASUrl(event.fileName);
                                },
                                onDone: { target: "uploadingFile" },
                                onError: { target: "#fileMachine.loadedFiles" },
                            },
                        },
                        uploadingFile: {
                            tags: "showUploadUI",
                            invoke: {
                                id: "uploadingFile",
                                src: (context, event) => {
                                    return FileUploadModule.uploadFile(context.uploadedFile);
                                },
                                onDone: { target: "saveFile" },
                                onError: { target: "#fileMachine.loadedFiles" },
                            },
                        },
                        saveFile: {
                            tags: "showUploadUI",
                            invoke: {
                                id: "saveFile",
                                src: (context, event) => {
                                    return FileUploadModule.saveFile(context.uploadedFile);
                                },
                                onDone: { target: "#fileMachine.gettingFiles", actions: ["showFileUploadSuccessMessage", "clearFile"] },
                                onError: { target: "#fileMachine.loadedFiles" },
                            },
                        },
                    },
                },
                deleteFile: {
                    tags: "showDeleteUI",
                    on: {
                        DELETING_FILE: { target: "#fileMachine.loadedFiles.deletingFile" },
                        CANCEL_FILE: { target: "#fileMachine.loadedFiles" },
                    },
                },
                deletingFile: {
                    tags: "showDeleteUI",
                    invoke: {
                        id: "deletingFile",
                        src: (context, event) => {
                            return FileUploadModule.DeleteFile(event.fileId);
                        },
                        onDone: { target: "#fileMachine.gettingFiles", actions: ["showSuccessMessage", "setPage"] },
                        onError: { target: "#fileMachine.loadedFiles" },
                    },
                },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        showFileUploadSuccessMessage: (context, event) => {
            toaster.ShowSuccess("File has been uploaded successfully.");
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        assignFile: assign({
            uploadedFile: (context, event) => event.uploadedFile,
        }),
        clearFile: assign({
            uploadedFile: (context, event) => null,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default fileListingMachine;
